import lrAreaSelect from './_src/lrAreaSelect.vue'

lrAreaSelect.install = function(Vue) {
  Vue.component(lrAreaSelect.name, lrAreaSelect)
}

export default lrAreaSelect